// extracted by mini-css-extract-plugin
module.exports = {"Featureone":"Featureone_Featureone__LgJCt"};